import React from 'react';
import { Typography, Button, Card, CardActions, CardContent, CardMedia} from '@material-ui/core';

import useStyles from './styles';

const CartItem = ({ item, onUpdateCartQty, onRemoveFromCart }) => {
  const classes = useStyles();

  const handleUpdateCartQty = (lineItemId, newQuantity) => onUpdateCartQty(lineItemId, newQuantity);

  const handleRemoveFromCart = (lineItemId) => onRemoveFromCart(lineItemId);

  return (
    // <div className={classes.root}>
    //   <Paper className={classes.paper}>
    //     <Grid container spacing={2}>
    //       <Grid item>
    //         <ButtonBase className={classes.image}>
    //           <img className={classes.img} alt={item.name} src={item.media.source} />
    //         </ButtonBase>
    //       </Grid>
    //       <Grid item xs={12} sm container>
    //         <Grid item xs container direction="column" spacing={2}>
    //           <Grid item xs>
    //             <Typography gutterBottom variant="h5">
    //               {item.name}
    //             </Typography>
    //             <Button variant="contained" type="button" className={classes.removeButton} onClick={() => handleRemoveFromCart(item.id)}>Remove</Button>
    //           </Grid>

    //         </Grid>
    //         <Grid item className={classes.buttons}>
    //           <Typography variant="subtitle1" style={{'fontWeight':'bold'}}>{item.line_total.formatted_with_symbol}</Typography>
    //           <Button type="button" size="small" onClick={() => handleUpdateCartQty(item.id, item.quantity - 1)}>-</Button>
    //               <Typography>&nbsp;{item.quantity}&nbsp;</Typography>
    //               <Button type="button" size="small" onClick={() => handleUpdateCartQty(item.id, item.quantity + 1)}>+</Button>
    //         </Grid>
            
    //       </Grid>
    //     </Grid>
    //   </Paper>
    // </div>

    <Card className="cart-item">
      <CardMedia image={item.media.source} alt={item.name} className={classes.media} />
      <CardContent className={classes.cardContent}>
        <Typography variant="h5">{item.name}</Typography>
        <Typography variant="h5">{item.line_total.formatted_with_symbol}</Typography>
      </CardContent>
      <CardActions className={classes.cardActions}>
        <div className={classes.buttons}>
          <Button tsdype="button" size="small" onClick={() => handleUpdateCartQty(item.id, item.quantity - 1)}>-</Button>
          <Typography>&nbsp;{item.quantity}&nbsp;</Typography>
          <Button type="button" size="small" onClick={() => handleUpdateCartQty(item.id, item.quantity + 1)}>+</Button>
        </div>
        <Button variant="contained" type="button" className={classes.removeButton} onClick={() => handleRemoveFromCart(item.id)}>Remove</Button>
      </CardActions>
    </Card>
  );
};

export default CartItem;
